import api from './api';

const oxiDequeueService = {
    list:        (params) => api.get('/admin/oxi-dequeue-queue', { params }),
    listHistory: (params) => api.get('/admin/oxi-dequeue-queue', { params: { ...params, history: 1 } }),
    historyDetail: (id)   => api.get('/admin/oxi-dequeue-queue', { params: { history: 1, id } }),
    remove:      (id)     => api.delete(`/admin/oxi-dequeue-queue/${id}`),
    purge:       (params) => api.delete('/admin/oxi-dequeue-queue/purge', { params }),
};

export default oxiDequeueService;
